module.exports = __webpack_public_path__ + "static/media/paidStamp.6edd9d55.png";